module.exports = __webpack_public_path__ + "img/icon_two_section_101.3c127c20.svg";